export const PAYROLL_SCHOOL_SECTIONS = [
  "Upper Primary",
  "Lower Primary",
  "Boarding",
  "Nursery School",
  "Estates",
  "Support Staff",
];

export const PAYROLL_SCHOOL_SECTION_OPTIONS = PAYROLL_SCHOOL_SECTIONS.map(
  (value) => ({ value, label: value }),
);

export const LEGACY_PAYROLL_SCHOOL_SECTIONS = [
  "Upper School",
  "Lower School",
  "Whole School",
  "Other",
];

export const PAYROLL_SCHOOL_SECTION_FILTER_OPTIONS = [
  ...PAYROLL_SCHOOL_SECTION_OPTIONS,
  ...LEGACY_PAYROLL_SCHOOL_SECTIONS.map((value) => ({
    value,
    label: `${value} (legacy)`,
  })),
];

export const getPayrollSchoolSectionOptions = (currentValue) => {
  if (!currentValue || PAYROLL_SCHOOL_SECTIONS.includes(currentValue)) {
    return PAYROLL_SCHOOL_SECTION_OPTIONS;
  }

  return [
    ...PAYROLL_SCHOOL_SECTION_OPTIONS,
    { value: currentValue, label: `${currentValue} (current)` },
  ];
};
